import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from 'react-router-dom'
import "./layout.css";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { connect } from "react-redux";

const Layout = ({ props, labelDisplay }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const location = useLocation()

  useEffect(() => {
    setIsOpen(false)
  }, [location])

  return (
    <>
      {labelDisplay?.includes("ECONNREFUSED") ? <div className="d-flex p-5 shadow  mx-auto w-50 mt-5 rounded-5 align-items-center justify-content-center">{labelDisplay}</div> :
        <> <Sidebar toggleClassName={isOpen} toggleAction={toggle} />
          <div className="adminSideBarRight theme-bg-color-secondary">
            <Header props={{ ...props }} toggleAction={toggle} />
            <div className="p-md-4 p-sm-2 p-0 adminHeadContainer mb-5">
              <Outlet />
            </div>
            <Footer />
          </div>
        </>
      }
    </>
  );
};

const mapStateToProps = (state) => ({
  labelDisplay: state.sideBar.labelDisplay,
});
export default connect(mapStateToProps)(Layout)

